import React, { lazy, useMemo } from 'react';
import ParentStyled from '../style';
import { useTranslation } from 'react-i18next';
import { loadStyle } from 'globalutils/fmUtils';
import RenderComponent from './RenderComponent';
import { initValues } from './config';
import { schema } from './schema';

const Styled = loadStyle(ParentStyled, 'pages/web/CompanyManagement');
const layout = window.$environment?.CURRENT_LAYOUT;
const Form = lazy(() => import(`globalcomponents/UI/Form/${layout}`));

const ScoreManagement = (props) => {
  const { i18n } = useTranslation();
  const { handleCancel, updateScores, scoreValues, companyId } = props;

  const initialValues = useMemo(() => {
    if (scoreValues && Object.keys(scoreValues).length) {
      const initial = {};
      if (scoreValues.behaviorScores)
        scoreValues.behaviorScores.forEach((ele) => {
          initial[ele.behavior.toLowerCase()] = String(ele.score);
        });
      if (scoreValues.severityScores)
        scoreValues.severityScores.forEach((ele) => {
          initial[`severity_${ele.severity.toLowerCase()}`] = String(ele.score);
        });
      return initial;
    }

    return initValues;
  }, [scoreValues]);

  const handleSubmit = (fields) => {
    const payload = {
      companyId: Number(companyId),
      behaviorScores: [],
      severityScores: [],
    };
    Object.keys(fields).forEach((ele) => {
      if (ele.includes('severity_')) {
        payload.severityScores.push({
          severity: ele.split('severity_')[1].toUpperCase(),
          score: Number(fields[ele]),
        });
      } else {
        payload.behaviorScores.push({
          behavior: ele.toUpperCase(),
          score: Number(fields[ele]),
        });
      }
    });
    updateScores({
      data: payload,
      apiId: 'updateScores',
    });
  };

  return (
    <>
      <Form
        type="server"
        direction="column"
        initialValues={initialValues}
        RenderComponent={RenderComponent}
        handleOnSubmit={handleSubmit}
        customProps={{
          Styled,
          i18n,
        }}
        handleOnCancel={() => {
          handleCancel();
        }}
        validationSchema={schema}
      />
    </>
  );
};

export default ScoreManagement;
